import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';

class PredictiveMediaServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  upload(instance_id, params) {
    return this.http.post(`${instance_id}`, params);
  }

  getList(instance_id) {
    return this.http.get(`${instance_id}`);
  }

  removeItem(mediafile_id) {
    return this.pure_http.delete(`mediafiles/${mediafile_id}`);
  }
}

export const PredictiveMediaService = new PredictiveMediaServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'mediafiles/instance'
});
